import type { ReactNode } from "react";

/*
 * Lucide-Symbole der Editor-Einfassung als Inline-Linien (R-F: Lucide; das Bausteinpaket führt keine Symbol-Bibliothek als
 * Abhängigkeit, wie `AnsichtWahl`). Pfade 1:1 aus lucide (bold, italic, heading-2, heading-3, list, list-ordered,
 * square-check-big, link, link-2-off, undo-2, redo-2, quote, minus, check, loader-circle, pilcrow).
 */
export function Lucide({ children }: { children: ReactNode }) {
  return (
    <>
      {/* Preline: forms/forms-sub-core-inputs-layouts/forms-cat-text-editors/rich-text-editor-card */}
      <svg
        className="shrink-0 size-4"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {children}
      </svg>
    </>
  );
}

export const SymFett = () => (
  <Lucide>
    <path d="M14 12a4 4 0 0 0 0-8H6v8" />
    <path d="M15 20a4 4 0 0 0 0-8H6v8Z" />
  </Lucide>
);
export const SymKursiv = () => (
  <Lucide>
    <line x1="19" x2="10" y1="4" y2="4" />
    <line x1="14" x2="5" y1="20" y2="20" />
    <line x1="15" x2="9" y1="4" y2="20" />
  </Lucide>
);
export const SymUeberschrift1 = () => (
  <Lucide>
    <path d="M4 12h8" />
    <path d="M4 18V6" />
    <path d="M12 18V6" />
    <path d="m17 12 3-2v8" />
  </Lucide>
);
export const SymUeberschrift2 = () => (
  <Lucide>
    <path d="M4 12h8" />
    <path d="M4 18V6" />
    <path d="M12 18V6" />
    <path d="M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1" />
  </Lucide>
);
export const SymUeberschrift3 = () => (
  <Lucide>
    <path d="M4 12h8" />
    <path d="M4 18V6" />
    <path d="M12 18V6" />
    <path d="M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2" />
    <path d="M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2" />
  </Lucide>
);
export const SymListe = () => (
  <Lucide>
    <path d="M3 12h.01" />
    <path d="M3 18h.01" />
    <path d="M3 6h.01" />
    <path d="M8 12h13" />
    <path d="M8 18h13" />
    <path d="M8 6h13" />
  </Lucide>
);
export const SymNummerierung = () => (
  <Lucide>
    <path d="M10 12h11" />
    <path d="M10 18h11" />
    <path d="M10 6h11" />
    <path d="M4 10h2" />
    <path d="M4 6h1v4" />
    <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" />
  </Lucide>
);
export const SymAufgabenliste = () => (
  <Lucide>
    <path d="M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5" />
    <path d="m9 11 3 3L22 4" />
  </Lucide>
);
export const SymLink = () => (
  <Lucide>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </Lucide>
);
export const SymLinkAus = () => (
  <Lucide>
    <path d="M9 17H7A5 5 0 0 1 7 7" />
    <path d="M15 7h2a5 5 0 0 1 4 8" />
    <line x1="8" x2="12" y1="12" y2="12" />
    <line x1="2" x2="22" y1="2" y2="22" />
  </Lucide>
);
export const SymRueckgaengig = () => (
  <Lucide>
    <path d="M9 14 4 9l5-5" />
    <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11" />
  </Lucide>
);
export const SymWiederholen = () => (
  <Lucide>
    <path d="m15 14 5-5-5-5" />
    <path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13" />
  </Lucide>
);
export const SymZitat = () => (
  <Lucide>
    <path d="M17 6H3" />
    <path d="M21 12H8" />
    <path d="M21 18H8" />
    <path d="M3 12v6" />
  </Lucide>
);
export const SymTrennlinie = () => (
  <Lucide>
    <path d="M5 12h14" />
  </Lucide>
);
export const SymHaken = () => (
  <Lucide>
    <path d="M20 6 9 17l-5-5" />
  </Lucide>
);
export const SymLaedt = () => (
  <Lucide>
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </Lucide>
);
export const SymAbsatz = () => (
  <Lucide>
    <path d="M13 4v16" />
    <path d="M17 4v16" />
    <path d="M19 4H9.5a4.5 4.5 0 0 0 0 9H13" />
  </Lucide>
);
